module.exports = __webpack_public_path__ + "static/media/Seismic_Table_C1_C2_UK.11ace39c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Seismic_Table_C1_C2_UK.png
// module id = 1329
// module chunks = 0